import React from 'react';
import { motion } from 'framer-motion';
import "./AboutStyles.scss"
import Contact from '../Contact/Contact';
import SpotifyPlaying from '../Spotify/SpotifyPlaying';


const About = () => {
    return (
        <div className="about">
            <div className="main-text">
            <motion.div 
                    className="main-text"
                    initial={{
                        opacity: 0,
                        y: 40,
                    }}
                    animate={{
                        opacity: 1,
                        y: 0,
                    }}
                    transition={{duration: 1, delay: 1.25, ease: "easeOut"}}
                >
            <h1>
                Yousef Yassin
            </h1>
            </motion.div>
            </div>
            <div className="content">
                <div className="description">
                    <div className='content'>
                        <motion.div 
                            className="main-text"
                            initial={{
                                opacity: 0,
                                y: 20,
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{duration: 1, delay: 1.35, ease: "easeOut"}}
                        >
                            <p className="emph">
                                I am a Software developer and creative designer based in Ontario, Canada. I'm currently studying 
                                Computer Systems Engineering and enjoy experimenting with all flavours of software.
                            </p>
                        </motion.div>
                        <motion.div 
                            className="main-text"
                            initial={{
                                opacity: 0,
                                y: 20,
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{duration: 1, delay: 1.45, ease: "easeOut"}}
                        >
                            <p>
                                My belief is that the root of effective product design is understanding the human experience
                                that lies behind it. I enjoy using my skill-set both at a lower level - to construct performant and 
                                robust systems - and also at a high level, to design a convenient solution that helps people accomplish
                                their goals.
                            </p>
                        </motion.div>
                        <motion.div 
                            className="main-text"
                            initial={{
                                opacity: 0,
                                y: 20,
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{duration: 1, delay: 1.55, ease: "easeOut"}}
                        >
                            <p>
                                Rather than sticking to a specific development stack, I'm very flexible in choosing the tools that
                                best suit the situation. That being said, I often find myself with TypeScript and React when doing 
                                frontend work.
                            </p>
                        </motion.div>
                        <motion.div 
                            className="main-text"
                            initial={{
                                opacity: 0,
                                y: 20,
                            }}
                            animate={{
                                opacity: 1,
                                y: 0,
                            }}
                            transition={{duration: 1, delay: 1.65, ease: "easeOut"}}
                        >
                            <p>
                                I'm also very comfortable and enjoy working in fullstack environments: effectively applying a 
                                variety of languages and paradigms to tackle the most challenging tasks. 
                            </p>
                        </motion.div>
                    </div>
                </div>
                <div className="tools">
                    <div className="tools title">
                        <h2>
                            <span className="line">
                                <span className="line-inner">
                                    Tools
                                </span>
                            </span>
                            <span className="line">
                                <span className="line-inner">
                                    & Tech
                                </span>
                            </span>
                        </h2>
                    </div>
                    <div className='content'>
                        <span>Typescript</span>
                        <span>React</span>
                        <span>Python</span>
                        <span>Java</span>
                        <span>C, C++, C#</span>
                        <span>OpenCV & Eigen</span>
                        <span>Mocha, Jest</span>
                        <span>Docker</span>
                        <span>Linux</span>
                        <span>MongoDB, SQL</span>
                        <span>HTML, SCSS</span>
                        <span>GraphQL</span>
                    </div>
                </div>
                <div className="favourites">
                    <div className="favourites title">
                        <h2>Current Favourites</h2>
                    </div>
                    <p className='content'>
                        <ul>
                            <li className='text-reveal'>
                                <p className="topic">
                                    Dev tool
                                </p>
                                <p className="subject">
                                    Copilot
                                </p>
                            </li>
                            <li className='text-reveal'>
                                <p className="topic">
                                    Colours
                                </p>
                                <p className="subject">
                                    <a className="subject-a" target="_blank" href="https://www.google.com/search?q=%23181818">#181818, </a>
                                    <a className="subject-a" target="_blank" href="https://www.google.com/search?q=%23cbc3e3">#cbc3e3, </a>
                                    <a className="subject-a" target="_blank" href="https://www.google.com/search?q=%23eae3c9">#eae3c9 </a>
                                </p>
                            </li>
                            <li className='text-reveal'>
                                <p className="topic">
                                    VS code theme
                                </p>
                                <p className="subject">
                                    Horizon Italic (Dark)
                                </p>
                            </li>
                            <li className='text-reveal'>
                                <p className="topic">
                                    Book
                                </p>
                                <p className="subject">
                                    <a className="subject-a" target="_blank" href="https://www.goodreads.com/book/show/17667561-the-shadow-throne">The Shadow Throne </a>
                                </p>
                            </li>
                            <li className='text-reveal'>
                                <p className="topic">
                                    Media
                                </p>
                                <p className="subject">
                                    <a className="subject-a" target="_blank" href="https://www.imdb.com/title/tt2560140/">Attack on Titan, </a>
                                    <a className="subject-a" target="_blank" href="https://www.anime-planet.com/manga/the-beginning-after-the-end">The Beginning After The End, </a>
                                    <a className="subject-a" target="_blank" href="https://www.anime-planet.com/manga/nano-machine/reviews">Nano Machine</a>
                                </p>
                            </li>
                            <li className='text-reveal'>
                                <p className="topic">
                                    Music
                                </p>
                                <p className="subject">
                                    <div className="songs">
                                        <a className="subject-a" target="_blank" href="https://open.spotify.com/track/6zAiRKvAMlXHxEtyO4yxIO?si=df354a82cd1c4a6c">Pheonix, </a>
                                        <a className="subject-a" target="_blank" href="https://open.spotify.com/track/5y4XJ9UFS5eOdoYPF5pSAE?si=316ddf90db4642d8">There you are, </a>
                                        <a className="subject-a" target="_blank" href="https://open.spotify.com/track/4Oih3RDrSFg3afaOphBVuy?si=5c1bf0404d204091">What could have been</a>
                                    </div>
                                    <SpotifyPlaying />
                                </p>
                                
                            </li>
                        </ul>
                    </p>
                </div>
                <Contact />
            </div>
        </div>
    );
};

export default About;